import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './theme.css';
import App from './App.jsx';
import * as tg from './lib/tg.js';

// Tell Telegram the Mini App is ready, expand to full height, and paint the
// initial theme (data-theme + themeParams → CSS vars) BEFORE first render so
// there is no light-flash on a dark client.
tg.applyTheme();
tg.ready();
tg.expand();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
